import { GET_CRITEO_AUTHENTICATION_URL } from './actions';
import { ReduxAsyncActionsService } from '../../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../../types/ReduxAsyncActions.types';
import type { CriteoState } from './Criteo.types';
import { INIT_STATE } from './Criteo.constants';
import type { CriteoAction } from './actions';
import { GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS } from '../actions/getSANAdPartnerZeitStatus';

function handler(state: WrappedReducer<CriteoState>, action: CriteoAction): WrappedReducer<CriteoState> {
  switch (action.type) {
    case GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS.response:
      const { a_criteo } = action.data || {};
      return {
        ...state,
        adAccountStatuses: a_criteo,
        loading: false,
      };

    case GET_CRITEO_AUTHENTICATION_URL.response:
      const { url } = action.data;
      return {
        ...state,
        authenticationUrl: url,
        loading: false,
      };

    default:
      return state;
  }
}

const Criteo = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [GET_CRITEO_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS],
  error: [GET_CRITEO_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS],
  resetOn: ['APP_CHANGE'],
});

export default Criteo;
